(function() {
  'use strict';

  function minLimit() {
    var minLimit = {};

    function link($scope, $element, $attr, $ctrl) {

      if (!$ctrl) return;

      var minLimit;

      $ctrl.$validators.minLimit = function(modelValue, viewValue) {
        return $ctrl.$isEmpty(modelValue) || !angular.isDefined(minLimit) || modelValue >= minLimit;
      };

      $attr.$observe('minLimit', function(value) {
        minLimit = Number(value) || 0.01;
        $ctrl.$validate();
      });

    }

    minLimit.restrict = 'A';
    minLimit.require = 'ngModel';
    minLimit.link = link;

    return minLimit;

  }

  angular
    .module('mandaeApp')
    .directive('minLimit', minLimit);

}());
